import * as React from 'react';
import { translate } from 'react-i18next';
import { browserHistory } from 'react-router';
import * as c from 'models/constants';
import { LoadingOverlayWrapper, ItemCardList } from 'components';
import { IItemCardList } from 'models/itemcard';
import { IOrderListItem } from 'models/orders/order';
import { IModalAction } from 'models/modal';
import { OrderStatus } from 'models';
import { IOrdersAction } from 'models/orders/orders';
require('./style.css');

interface IProps {
	shopId: string;
	orders: any;
	isFetchingOrders: boolean;
	showModal: (modalType: string, modalProps: any) => IModalAction;
	closeModal: () => IModalAction;
	setStatus?: (shopOrderId: string, shopId: string, status: OrderStatus, note: string) => IOrdersAction;
	t?: (key: string, object?: any) => string;
}

interface IShopOrdersCardList extends IItemCardList {
	rejectOrder?: (item: IOrderListItem) => void;
	confirmOrder?: (shopOrderId: string) => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class DashboardOrders extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.viewItem = this.viewItem.bind(this);
		this.rejectOrder = this.rejectOrder.bind(this);
		this.confirmOrder = this.confirmOrder.bind(this);
		this.openRejectOrder = this.openRejectOrder.bind(this);
	}

	private viewItem(id: string) {
		browserHistory.push('/shop/' + this.props.shopId + '/edit/orders/order/' + id);
	}

	private openRejectOrder(item: IOrderListItem) {
		this.props.showModal('RejectOrder', {
			item,
			closeModal: this.props.closeModal,
			rejectOrder: this.rejectOrder,
		});
	}

	private rejectOrder(shopOrderId: string, note: string) {
		this.props.setStatus(shopOrderId, this.props.shopId, OrderStatus.Rejected, note);
		this.props.closeModal();
	}

	private confirmOrder(shopOrderId: string) {
		this.props.setStatus(shopOrderId, this.props.shopId, OrderStatus.Processing, '');
		this.props.closeModal();
	}

	public render() {
		const { t } = this.props;
		const { isFetchingOrders, orders } = this.props;

		const listProps: IShopOrdersCardList = {
			items: orders,
			itemType: c.NODE_TYPE_SHOPDASHBOARD_ORDER_ITEM_CARD,
			viewItem: this.viewItem,
			rejectOrder: this.openRejectOrder,
			confirmOrder: this.confirmOrder,
		};

		return (
			<div className="shopDashboardOrders">
				<LoadingOverlayWrapper
					active={isFetchingOrders}
					spinner={true}
					text={t('BSPortal_Common_Loading')}
					background="rgba(0, 0, 0, 0.1)"
				>
					<ItemCardList {...listProps} />
				</LoadingOverlayWrapper>
			</div>
		);
	}
}

export { DashboardOrders };
